
  export default {
    props: {
      videos: { type: Array, default () { return []; } }
    }
  };
